import React from 'react';
import { Col, DatePicker, Form, FormInstance, Input, Row, Select, Switch } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'mixins/dayjsConfig';
import {
    HOME_BANNER_DATE_FORMAT,
    HOME_BANNER_REQUEST_DATE_FORMAT,
} from '../home-banners/constants';
import { HOME_BANNER_FORM_INITIAL_VALUES } from './helpers';
import { HomeBannerFormValues } from './types';
import HomeBannerImageUpload from './image-upload';

const { TextArea } = Input;

const getDatePickerValue = (value?: string) => ({ value: value ? dayjs(value) : null });
const normalizeDatePickerValue = (value?: Dayjs | null) =>
    value ? value.format(HOME_BANNER_REQUEST_DATE_FORMAT) : '';

type Props = {
    form: FormInstance<HomeBannerFormValues>;
    orderOptions: number[];
    onFinish: (values: HomeBannerFormValues) => void;
};

const HomeBannerForm = ({ form, orderOptions, onFinish }: Props) => (
    <Form<HomeBannerFormValues>
        className="home-banners-admin__form"
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={HOME_BANNER_FORM_INITIAL_VALUES}
    >
        <div className="home-banners-admin__form-sections">
            <section className="home-banners-admin__section">
                <div className="home-banners-admin__section-title">Заголовок и описание</div>
                <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Заголовок RU"
                            name="titleRu"
                            rules={[{ required: true, message: 'Введите заголовок RU' }]}
                        >
                            <Input maxLength={255} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Заголовок KK"
                            name="titleKk"
                            rules={[{ required: true, message: 'Введите заголовок KK' }]}
                        >
                            <Input maxLength={255} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Описание RU"
                            name="descriptionRu"
                        >
                            <TextArea rows={5} maxLength={600} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Описание KK"
                            name="descriptionKk"
                        >
                            <TextArea rows={5} maxLength={600} />
                        </Form.Item>
                    </Col>
                </Row>
            </section>

            <section className="home-banners-admin__section">
                <div className="home-banners-admin__section-title">Ссылка и публикация</div>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item
                            label="Ссылка перехода"
                            name="linkUrl"
                            rules={[{ required: true, message: 'Введите ссылку перехода' }]}
                        >
                            <Input placeholder="https://example.kz" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                        <Form.Item
                            label="Дата начала"
                            name="publishStartDate"
                            getValueProps={getDatePickerValue}
                            normalize={normalizeDatePickerValue}
                        >
                            <DatePicker
                                allowClear
                                format={HOME_BANNER_DATE_FORMAT}
                                placeholder="Без ограничения"
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                        <Form.Item
                            label="Дата окончания"
                            name="publishEndDate"
                            getValueProps={getDatePickerValue}
                            normalize={normalizeDatePickerValue}
                        >
                            <DatePicker
                                allowClear
                                format={HOME_BANNER_DATE_FORMAT}
                                placeholder="Без ограничения"
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                        <Form.Item
                            label="Порядок отображения"
                            name="displayOrder"
                        >
                            <Select
                                options={orderOptions.map((value) => ({
                                    value,
                                    label: value,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </section>

            <section className="home-banners-admin__section">
                <div className="home-banners-admin__section-title">Изображение</div>
                <Form.Item
                    label="Изображение"
                    name="imageId"
                    rules={[{ required: true, message: 'Загрузите изображение' }]}
                >
                    <HomeBannerImageUpload />
                </Form.Item>
            </section>

            <section className="home-banners-admin__section home-banners-admin__section--status">
                <div>
                    <div className="home-banners-admin__status-title">Активен</div>
                    <div className="home-banners-admin__status-description">
                        Баннер отображается на главной странице
                    </div>
                </div>
                <Form.Item
                    name="enabled"
                    valuePropName="checked"
                    noStyle
                >
                    <Switch />
                </Form.Item>
            </section>
        </div>
    </Form>
);

export default HomeBannerForm;
